import {createProjectModel} from 'crm/utils/project-model'
import {getList, addUser, editUser, deleteUser, downloadTemplate, importGroupLink} from './service'

const model = createProjectModel({
    projectNamespace: 'employeeWelcome',

    state: {
        tableData: null,
    },

    effects: {
        *addUser({payload}, {call}) {
            return yield call(addUser, payload)
        },

        *editUser({payload}, {call}) {
            return yield call(editUser, payload)
        },

        *deleteUser({payload}, {call}) {
            return yield call(deleteUser, payload)
        },
        *downloadTemplate({payload}, {call}) {
            return yield call(downloadTemplate, payload)
        },
        *importGroupLink({payload}, {call}) {
            return yield call(importGroupLink, payload)
        },
        *getList(xx, {call, select, put}) {
            const {tableData} = yield select((allState) => allState[model.namespace])

            const newParams = {
                offset: tableData.pagination.pageSize * (tableData.pagination.current - 1),
                limit: tableData.pagination.pageSize,
                ...tableData.params,
            }

            const res = yield call(getList, newParams)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableData.dataSource = res.data
                    draft.tableData.pagination.total = res?.pagination?.rows_found ?? 0
                },
            })
        },
    },
})

export default model
